import { render, staticRenderFns } from "./ProductTagTranslationNewPopup.vue?vue&type=template&id=5201f6fc&"
import script from "./ProductTagTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProductTagTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports